import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { Plus, Upload, RotateCcw, CheckCircle2, RefreshCw } from "lucide-react";

export default function BulkTaxonomyToolbar({
  isSuperAdmin, summary,
  mode, setMode, partial, setPartial, autoCreate, setAutoCreate,
  busy, canImport,
  onLoadCurrent, onClearAll, onAddRow, onValidate, onImport,
}) {
  return (
    <div className="flex items-center gap-2 flex-wrap bg-slate-50 border-y border-slate-200 px-2 py-2 -mx-6">
      <Button size="sm" variant="outline" onClick={onLoadCurrent} data-testid="load-current-btn">
        <Upload className="w-3.5 h-3.5 mr-1.5" /> Load current taxonomy
      </Button>
      <Button size="sm" variant="outline" onClick={onClearAll} data-testid="clear-all-btn">
        <RotateCcw className="w-3.5 h-3.5 mr-1.5" /> Clear all
      </Button>
      <Button size="sm" variant="outline" onClick={onAddRow} data-testid="add-row-btn">
        <Plus className="w-3.5 h-3.5 mr-1.5" /> Add row
      </Button>
      <div className="ml-auto flex items-center gap-2.5 text-xs">
        <span className="text-slate-500">Mode</span>
        <Select value={mode} onValueChange={setMode}>
          <SelectTrigger className="h-9 w-44 text-xs" data-testid="bulk-mode-select"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="skip">Skip if exists</SelectItem>
            <SelectItem value="update">Update auto-fill</SelectItem>
            {isSuperAdmin && <SelectItem value="replace">Replace all</SelectItem>}
          </SelectContent>
        </Select>
        <label className="flex items-center gap-1.5 cursor-pointer">
          <Checkbox checked={partial} onCheckedChange={(v) => setPartial(!!v)} data-testid="partial-toggle" />
          <span className="text-slate-600">Partial</span>
        </label>
        <label className="flex items-center gap-1.5 cursor-pointer">
          <Checkbox checked={autoCreate} onCheckedChange={(v) => setAutoCreate(!!v)} data-testid="autocreate-toggle" />
          <span className="text-slate-600">Auto-create FKs</span>
        </label>
        <Button size="sm" variant="outline" onClick={onValidate} disabled={busy} data-testid="validate-btn">
          <RefreshCw className={`w-3.5 h-3.5 mr-1.5 ${busy ? "animate-spin" : ""}`} /> Validate
        </Button>
        <Button size="sm" onClick={onImport} disabled={busy || !canImport} className="bg-indigo-600 hover:bg-indigo-700" data-testid="import-btn">
          <CheckCircle2 className="w-3.5 h-3.5 mr-1.5" /> Import {summary ? `${summary.rows_valid}` : ""}
        </Button>
      </div>
    </div>
  );
}
